import { render, staticRenderFns } from "./EditGoodsShowInfo.vue?vue&type=template&id=f9d2ad44"
import script from "./EditGoodsShowInfo.vue?vue&type=script&lang=js"
export * from "./EditGoodsShowInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports